import Vue from 'vue'
import VueNativeSock from 'vue-native-websocket'
import store from '../store'

Vue.use(VueNativeSock, `${process.env.VUE_APP_WS_URL}/ws?token=${localStorage.getItem('token')}`, {
    store: store,
    mutations: mutations,
    format: 'json',
    connectManually: true,
    // reconnection: true, // (Boolean) whether to reconnect automatically (false)
    // reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
    // reconnectionDelay: 3000,
})

let interval = null
const vm = new Vue()
const connectWS = () => {
    vm.$connect()
    interval = setInterval(() => {
        try {
            if (vm.$socket.readyState == 1) {
                vm.$socket.send("PING")
            }
        } catch(e) {
            console.error(e)
        }
    }, 2000)
}
const disconnectWS = () => {
    vm.$disconnect()
    clearInterval(interval)
}

export const state = {
    socket: {
        isConnected: false,
        message: '',
        reconnectError: false,
    }
}

export const mutations = {
    SOCKET_ONOPEN(state, event) {
        Vue.prototype.$socket = event.currentTarget
        state.socket.isConnected = true
    },
    SOCKET_ONCLOSE(state) {
        state.socket.isConnected = false
    },
    SOCKET_ONERROR(state, event) {
        console.error(state, event)
        // state.socket.isConnected = false
        // disconnectWS();
    },
    // default handler called for all methods
    SOCKET_ONMESSAGE(state, message) {
        state.socket.message = message
    },
    // mutations for reconnect methods
    SOCKET_RECONNECT(state, count) {
        console.log(state, count)
    },
    SOCKET_RECONNECT_ERROR(state) {
        state.socket.reconnectError = true;
    },
}

export const actions = {
    WSConnect() {
        connectWS()
    },
    WSDisconnect() {
        disconnectWS()
    },
}